import "../../styles/Authentication.scss";
import { useLabelsContext } from "../../context/LabelsContext";
import { useAuthContext } from "../../context/AuthContext";

export const OtpFormHeader: React.FC = () => {
	const { labels } = useLabelsContext();
	const { otpSentMessage } = useAuthContext();

	if (!otpSentMessage) return null;

	const [labelText = "", targetValue = ""] = otpSentMessage.split(":");

	return (
		<div className='form-header text-center'>
			<span className='form-header-title'>
				{labels?.["OTPMailHeader"]}
			</span>
			<span className='form-header-text'>
				{labelText.trim()}&nbsp;
				<span
					style={{
						direction: "ltr",
						display: "inline-block",
					}}
				>
					{targetValue.trim()}
				</span>
			</span>
		</div>
	);
};
